import React from "react";
import PropTypes from "prop-types";
import { MenuItem, TextField } from "@mui/material";

// Purchase source filter for the purchase reports (Reports page, both tabs):
// Website = Razorpay orders made on the website; App = Razorpay orders made in
// the app plus every Apple order; All = everything, including Razorpay orders
// with no recorded source. Sent to the report as &source=.
export const PURCHASE_SOURCES = [
  { value: "ALL", label: "All" },
  { value: "WEBSITE", label: "Website" },
  { value: "APP", label: "App" },
];

const PurchaseSourceSelect = ({ formik }) => (
  <TextField
    select
    size="small"
    label="Source"
    name="source"
    value={formik.values.source}
    onChange={formik.handleChange}
    sx={{ minWidth: 140 }}
  >
    {PURCHASE_SOURCES.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
);

PurchaseSourceSelect.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default PurchaseSourceSelect;
